/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class GitVersionInfo {
    semVer: string;
    fullSemVer: string;
    informationalVersion: string;
    shortSha: string;
    commitDate: string;
}
